export default __webpack_public_path__ + "static/media/cwye-logo.6797583c.png";